import { Divider } from "@mui/material";
import React from "react";

const TempLabel = ({ children }) => {
  return (
    <div className="flex gap-1 items-center">
      <div className="w-4 h-4 bg-orange-200 rounded-[50%]" />
      {children}
    </div>
  );
};

export default TempLabel;
